import styled from 'styled-components'

import { Image } from '@application/Interfaces/Atoms/Image'
import { ThemeModeType } from '@application/Types/ComponentTypes'
import { Tabs as TabsBase } from '@icontainers/design-system/dist/organisms/Tabs'
import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const TitleSection = styled(TitleSectionBase)`
    background-color: ${(props) => props.theme.color[props.mode === 'Dark' ? 'p600' : 'g100']};
`

export const Tabs = styled(TabsBase)`
    @media ${(props) => props.theme.query.mobile} {
        &.root {
            border-left: 0;
            border-right: 0;
            border-radius: 0;
            margin-left: -30px;
            margin-right: -30px;
        }
    }
`

export const ImageWrapper = styled.div`
    transition: transform 0.5s linear 0s;
    width: 55px;
    height: 55px;
    padding: 11px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.color.p100};
    margin-bottom: 8px;
`

export const Icon = styled(Image)`
    max-width: 33px;
`

export const ItemTitle = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.p500};
    margin-bottom: 8px;
    line-height: 180%;
`

export const ItemDescription = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};
    margin-bottom: 16px;
    line-height: 180%;
`

export const ReadMore = styled(LinkBase)`
    display: flex;
    flex: 1;
    text-decoration: none;
    align-items: center;
    text-transform: uppercase;
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.p500};

    svg {
        margin-left: 8px;
    }
`

export const Item = styled.div<{ $mode: ThemeModeType }>`
    border-radius: 8px;
    ${(props) => props.theme.boxShadow.level1};
    background-color: ${(props) => props.theme.color.white};
    padding: 16px;
    height: 100%;

    &:hover,
    &:focus,
    &:active {
        ${ImageWrapper} {
            transform: translateY(-5px);
        }
    }

    ${ReadMore} {
        &:hover,
        &:focus,
        &:active {
            color: ${(props) => props.theme.color.a500};

            svg path {
                fill: ${(props) => props.theme.color.a500};
                stroke: ${(props) => props.theme.color.a500};
            }
        }
    }
`

export const CTALink = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    display: block;
    text-decoration: none;

    @media ${(props) => props.theme.query.mobile} {
        width: 100%;

        & > div {
            display: block;

            button {
                width: 100%;

                span:first-child {
                    margin: 0px;
                }
            }
        }
    }
`
